// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"09659c63","112":"965395d3","319":"42430125","453":"3d527c62","461":"7754fc4f","526":"bc3eb991","591":"0df536d3","594":"25cc0435","694":"d38ffd7a","718":"70b4c47d","758":"95aefb35","885":"22cbff05","931":"96ffb53a","986":"74d6daf1"}[chunkId] + ".chunk.js";
};